import React from 'react'

export default function About(){
    return(
        <>
            <h1>About Us Page finnovate</h1> <br/> <a href='/'>home page</a>
        </>
    )
}